const validate = values => {
    const errors = {}
    const requiredFields = [
        'email',
        'oldPassword',
        'newPassword',
        'confirmNewPassword'
    ]

    requiredFields.forEach(field => {
        if (!values[field]) {
            errors[field] = 'fieldRequired'
        }
    });

    if (values.email && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
        errors.email = 'invalidEmail'
    }

    if (values.newPassword && values.confirmNewPassword && values.newPassword !== values.confirmNewPassword) {
        errors.confirmNewPassword = 'passwordsDoNotMatch'
    }

    return errors
}

export default validate;

//const validate = values => {
//    const errors = {}
//    const requiredFields = [
//        'email',
//        'oldPassword',
//        'newPassword',
//        'confirmNewPassword'
//    ]

//    requiredFields.forEach(field => {
//        if (!values[field]) {
//            errors[field] = 'Полето е задължително'
//        }
//    });

//    if (values.email && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
//        errors.email = 'Невалиден E-mail адрес'
//    }

//    if (values.newPassword && values.confirmNewPassword && values.newPassword !== values.confirmNewPassword) {
//        errors.confirmNewPassword = 'Паролите не съвпадат'
//    }

//    return errors
//}

//export default validate;